var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65307 17.7071C8.29987 18.0976 7.72724 18.0976 7.37405 17.7071C7.02086 17.3166 7.02086 16.6834 7.37405 16.2929L12.1609 11L7.37405 5.70711C7.02086 5.31658 7.02086 4.68342 7.37405 4.29289C7.72724 3.90237 8.29987 3.90237 8.65307 4.29289L14.0795 10.2929C14.4327 10.6834 14.4327 11.3166 14.0795 11.7071L8.65307 17.7071Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.633ba7a1e4d23ecb35e6114bc2079b05.svg";
export { ForwardRef as ReactComponent };